function ApiMessageReceiver(onStreamingMessageReceived) {
  // private
  var TypeIds = require('../api/type-ids.js');
  var RequestPatternType = require('../api/request-pattern-type.js');
  var callbacks = {
    query: {},
    replay: {},
    single: {}
  };
  var RequestConstants = require('../api/request/constants.js');
  var UniqueIdGenerator = require('../utils/uuid-generator.js');

  var realtimeDataRequestClientRefIds = {};

  function isQueryWithLastResponse(message) {
    return message.hasOwnProperty("lastResponse");
  }

  function handleQueryResponse(message) {
    if (message.data) {
      callbacks.query[message.clientRefId].data.push(message.data);
    }
    if (message.lastResponse) {
      var callback = callbacks.query[message.clientRefId].callback;
      var data = callbacks.query[message.clientRefId].data;
      delete callbacks.query[message.clientRefId];
      callback({
        typeName: message.typeName,
        context: message.context,
        typeId: message.typeId,
        clientRefId: message.clientRefId,
        data: data
      });
    }
  }

  function handleSingleRequestResponse(message) {
    if (callbacks.single[message.clientRefId]) {
      var callback = callbacks.single[message.clientRefId].callback;
      delete callbacks.single[message.clientRefId];
      callback(message);
    }
  }

  function handleReplayDatasetEvent(message) {
    // if (!isReplayDataResponseEvent(message)) {
      if (isReplayDataFinishedEvent(message) && callbacks.replay[message.clientRefId]) {
        var callback = callbacks.replay[message.clientRefId].callback;
        delete callbacks.replay[message.clientRefId];
        callback(message, true);
      }
      else if (callbacks.replay[message.clientRefId]) {
        var callback = callbacks.replay[message.clientRefId].callback;
        callback(message, false);
      }
    // }
  }

  function sortBasedOnTimestamp(data) {
    return data.sort(compareTimestamp);

    function compareTimestamp(a, b) {
      if (a.timestamp < b.timestamp) {
        return -1;
      }
      if (a.timestamp > b.timestamp) {
        return 1;
      }
      return 0;
    }
  }

  // for now there is no easy way to classify messages as ReplayDatasetEvent
  function isReplayDatasetEvent(clientRefId) {
    if (callbacks.replay.hasOwnProperty(clientRefId)) {
      return true;
    }
    else {
      return false;
    }
  }

  function isReplayDataFinishedEvent(message) {
    return message.lastResponse;
  }

  function isReplayDataResponseEvent(message) {
    return message.typeId === TypeIds.GetLatestDataResponse ||  message.typeId === TypeIds.GetDataByRecordLocationResponse;
  }

  // public
  this.registerCallback = function (request, requestPatternType, callback, clientReferenceId) {
    if (!clientReferenceId) clientReferenceId = UniqueIdGenerator.get();
    clientReferenceId = clientReferenceId.toLowerCase();
    request["clientRefId"] = clientReferenceId;

    if (isGetRealtimeData(request)) {
      if (!realtimeDataRequestClientRefIds[request.clientRefId]) {
        realtimeDataRequestClientRefIds[request.clientRefId] = {};
      }
    } else {
      var objToBeRegistered = {
        callback: callback,
        data: []
      };
      if (requestPatternType === RequestPatternType.QUERY) {
        callbacks.query[clientReferenceId] = objToBeRegistered;
      }
      else if (requestPatternType === RequestPatternType.REPLAY) {
        callbacks.replay[clientReferenceId] = objToBeRegistered;
      }
      else {
        callbacks.single[clientReferenceId] = objToBeRegistered;
      }
    }

    function isGetRealtimeData(request) {
      return request.typeId === TypeIds.SubscribeRealTimeData;
    }

  };

  this.handle = function (message) {
    var clientRefId = message.clientRefId;
    if (isStreamingMessage(message)) {
      // TODO: IN-324 this code is to be removed when IN-324 is going to be worked on later
      if (message.dataset == null) {
        message.dataset = message.context;
      }
      onStreamingMessageReceived(message);
    }
    else if (isQueryResponse(clientRefId)) {
      handleQueryResponse(message);
    }
    // replay data is a special case where an event is fired to let front-end know
    // an end has been reached
    else if (isReplayDatasetEvent(clientRefId)) {
      handleReplayDatasetEvent(message);
    }
    // else is single request-response type of response
    else {
      handleSingleRequestResponse(message);
    }

    function isStreamingMessage(message) {
      var isRealtimeDataResponse = realtimeDataRequestClientRefIds[clientRefId] ? true : false;
      delete realtimeDataRequestClientRefIds[clientRefId];

      return !clientRefId || isRealtimeDataResponse;
    }

    function isQueryResponse(clientRefId) {
      if (callbacks.query.hasOwnProperty(clientRefId)) {
        return true;
      }
      else {
        return false;
      }
    }
  }
}
module.exports = ApiMessageReceiver;


// WEBPACK FOOTER //
// ./src-client-lib/solace/api-message-receiver.js